import apiClient from "../../app/apiClient";

// Proposed backend routes; POST/DELETE methods are confirmed.
const endpoint = (projectId) => "/admin/project/" + encodeURIComponent(projectId) + "/publish";
export const projectPublishApi = {
  publish: ({ projectId, images }) => apiClient.post(endpoint(projectId), { projectId, images }),
  unpublish: (projectId) => apiClient.delete(endpoint(projectId)),
};
